import React from "react";
import { useRecordContext, ReferenceArrayField, useListContext, RecordContextProvider } from "react-admin";
import { getDisplayName } from "utils/helpers";
import { employeeRequests } from "api/employeeApi";

const EmployeeNames = () => {
  const { data = [] } = useListContext();
  return <span>{data.map(e => getDisplayName(e)).join(", ")}</span>;
};

const EmployeesField = ({ source }) => {
  const record = useRecordContext();
  const value = record?.[source];
  const ids = Array.isArray(value) ? value : value != null ? [value] : [];

  return (
    <RecordContextProvider value={{ ...record, [source]: ids }}>
      <ReferenceArrayField
        source={source}
        reference={employeeRequests.getEmployeesSelect()}
      >
        <EmployeeNames />
      </ReferenceArrayField>
    </RecordContextProvider>
  );
};

export default EmployeesField;
